import { Modal } from "bootstrap";

const hideModal = (modalEl: HTMLElement | null): void => {
  if (!modalEl) {
    return;
  }

  const myModal = Modal.getInstance(modalEl);
  myModal.hide();
};
const showModal = (modalEl: HTMLElement | null): void => {
  if (!modalEl) {
    return;
  }

  const myModal = Modal.getInstance(modalEl);
  myModal.show();
};

const removeModalBackdrop = (): void => {
  if (document.querySelectorAll(".modal-backdrop.fade.show").length) {
    document.querySelectorAll(".modal-backdrop.fade.show").forEach((item) => {
      item.remove();
    });
  }
};
const hideModalByClass = (modalClass): void => {
  if (document.querySelectorAll(modalClass).length) {
    document.querySelectorAll(modalClass).forEach((item) => {
      const myModal = Modal.getInstance(item);
      myModal.hide();
    });
  }
};
export { removeModalBackdrop, hideModal, showModal, hideModalByClass };
